/**
 * Compute environment rotation that keeps the rotation around the Y axis in sync with the camera view.
 * @param quaternion - Camera rotation.
 */
export function computeRotationFromCamera(camera) {
    const { quaternion } = camera;
    // Project quaternion onto the Y axis by discarding x/z, then extract the angle.
    // For q = (0, y, 0, w) normalized: angle = 2 * atan2(y, w). The normalization
    // factor sqrt(y²+w²) cancels, so we can use the raw components directly.
    return 2 * Math.atan2(quaternion.y, quaternion.w);
}
/**
 * Use a representative ligtness value to infer an environment intensity factor that plateaus the limits.
 * @param lightness - Lightness value in the [0, 1] interval, in linear space.
 */
export function computeExposureShiftFromLightness(lightness) {
    const xOffset = -0.15;
    const x = lightness + xOffset;
    // Use a shifted and scaled odd-degree polynomial (3, 5, 7),
    // giving a smooth ±0.4 nudge around the neutral value of 1.
    const shift = -0.2 * Math.pow(2 * x - 1, 9);
    console.log(`exposure shift: f(${lightness})=${shift}`);
    return shift;
}
export function getEnvironmentRotation(scene) {
    var _a, _b;
    const entity = scene.children.find(e => e.components.environment);
    const environmentComponent = entity.components.environment;
    const { environment } = environmentComponent;
    const environmentRotation = (_b = (_a = environmentComponent.rotation) !== null && _a !== void 0 ? _a : environment.rotation) !== null && _b !== void 0 ? _b : 0;
    return environmentRotation;
}
